<template>
  <div v-if="pageResolver">
    <Page :page-resolver="pageResolver" />
  </div>
</template>

<script setup lang="ts">
import type { Locale } from '~/utils/common';

import { useAppStore } from '~/stores/app/appStore';

const { locale, t } = useI18n();
const runtimeConfig = useRuntimeConfig();

const appStore = useAppStore();

const pageResolver = computed(() => appStore.getPageType(HOME_PAGE_SLUG, locale.value as Locale));

definePageMeta({
  layout: 'full',
});

useJsonld({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  contactPoint: {
    '@type': 'ContactPoint',
    areaServed: appStore.currentCountryCode,
    availableLanguage: locale.value,
    contactType: 'Customer service',
    telephone: runtimeConfig.public.supportPhone,
  },
  logo: `${runtimeConfig.public.baseUrl}/favicon.svg`,
  name: t('general.brandName'),
  sameAs: [
    runtimeConfig.public.facebookUrl,
    runtimeConfig.public.xTwitterUrl,
    runtimeConfig.public.instagramUrl,
    runtimeConfig.public.linkedinUrl,
  ],
  url: runtimeConfig.public.baseUrl,
});
</script>
